import { IndexTabsList, IndexTabTrigger, TabsGroup } from 'ui/tabsGroup';
import { useDevicePreviewContext } from '../context/DevicePreviewContext';
import { useState } from 'react';
import { DEFAULT_CATEGORY } from '../consts';
import { DevicePreviewGrid } from './DevicePreviewGrid';
import { ErrorBanner, InfoBanner } from 'ui/banner';
import { Breadcrumbs } from './Breadcrumbs';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';
import {
  Container,
  CountBadge,
  CountBadgeActive,
  EmptyGrid,
  Grid,
  LeftGridItem,
  RightGridItem,
  StyledHeading,
  TabTriggerText,
} from './Styled';
import { Skeleton } from 'ui/skeleton';
import { RegeneratePreviews } from './RegeneratePreviews';
import { EmptyStateFind } from 'ui/illustrations';
import { Link } from 'ui/links';

export const DevicePreviewContent = () => {
  const [category, setCategory] = useState(DEFAULT_CATEGORY);
  const { templateId, locale } = useQueryParamContext();
  const {
    devicePreviews,
    categoriesCount,
    isLoading,
    refetch,
    isEnabled,
    templateName,
    isTemplateError,
  } = useDevicePreviewContext();

  const filteredDevicePreviews =
    category === DEFAULT_CATEGORY
      ? devicePreviews
      : devicePreviews.filter((dp) => dp.category === category);

  return (
    <Container>
      <Grid>
        <LeftGridItem>
          <Breadcrumbs templateId={templateId} templateName={templateName} locale={locale} />
          <StyledHeading>Device previews {templateName ? `for ${templateName}` : ''}</StyledHeading>
        </LeftGridItem>
        <RightGridItem>
          <LocaleSwitcher isReadOnly hideErrorCount />
          {templateId && (
            <RegeneratePreviews
              templateId={templateId}
              locale={locale}
              refetch={refetch}
              isDisabled={!devicePreviews.length}
            />
          )}
        </RightGridItem>
      </Grid>
      <TabsGroup data-test="campaigns-tabs-filter" value={category}>
        <IndexTabsList>
          {Object.keys(categoriesCount).map((categoryKey) => (
            <IndexTabTrigger
              key={categoryKey}
              value={categoryKey}
              onClick={() => setCategory(categoryKey)}
            >
              <TabTriggerText>
                {categoryKey}
                {categoryKey === category ? (
                  <CountBadgeActive>{categoriesCount[categoryKey]}</CountBadgeActive>
                ) : (
                  <CountBadge>{categoriesCount[categoryKey]}</CountBadge>
                )}
              </TabTriggerText>
            </IndexTabTrigger>
          ))}
        </IndexTabsList>
      </TabsGroup>
      {isLoading && <Skeleton width="100%" height={46} />}
      {!isLoading && isEnabled && !!filteredDevicePreviews.length && (
        <InfoBanner>Please note that some previews can take up to 5 minutes to render.</InfoBanner>
      )}
      {!isLoading && !isEnabled && (
        <ErrorBanner>
          Device previews are not enabled for this project. Please contact your CSM for more
          information.
        </ErrorBanner>
      )}
      {isTemplateError ? (
        <EmptyGrid>
          <EmptyStateFind />
          <h4>This template may belong to another project, or it may have been deleted.</h4>
          <Link href="/templates">Back to All Templates</Link>
        </EmptyGrid>
      ) : (
        <DevicePreviewGrid devicePreviews={filteredDevicePreviews} isLoading={isLoading} />
      )}
    </Container>
  );
};
